import React from 'react';
import { Search, X } from 'lucide-react';
import styles from './SearchBar.module.css';

/**
 * SearchBar Component
 * Search input with icon and debounced search
 */
const SearchBar = ({ value, onChange, placeholder = "Search games...", onClear, readOnly = false, autoFocus = false }) => {
  const handleClear = (e) => {
    e.stopPropagation();
    if (onClear) {
      onClear();
    } else if (onChange) {
      // Create a synthetic event to clear the input
      const syntheticEvent = {
        target: { value: '' }
      };
      onChange(syntheticEvent);
    }
  };

  const handleClick = (e) => {
    if (readOnly) {
      e.preventDefault();
      e.stopPropagation();
      e.currentTarget.blur();
    }
  };

  const handleFocus = (e) => {
    if (readOnly) {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  return (
    <div className={styles.searchContainer}>
      <Search className={styles.searchIcon} size={20} />
      <input
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onClick={handleClick}
        onFocus={handleFocus}
        readOnly={readOnly}
        autoFocus={autoFocus && !readOnly}
        autoComplete="off"
        spellCheck="false"
      />
      {value && value.trim().length > 0 && !readOnly && (
        <button
          className={styles.clearButton}
          onClick={handleClear}
          aria-label="Clear search"
          type="button"
        >
          <X className={styles.clearIcon} size={18} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
